export const translations = {
  "zh-CN": {
    kicker: "独立第三方 · 资讯与推广指南",
    heroLine1: "亚洲体育",
    heroLine2: "与娱乐指南",
    heroSubtitle: "热门体育赛事、真人娱乐及电子游戏内容，查看当前平台活动与新用户优惠。",
    cta: "立即进入",
    categoriesHeading: "热门分类",
    sportsTitle: "体育赛事",
    sportsDesc: "足球、篮球等全球热门赛事内容与赛事情报。",
    casinoTitle: "真人娱乐",
    casinoDesc: "真人桌台互动，沉浸式豪华娱乐大厅体验。",
    slotsTitle: "电子游戏",
    slotsDesc: "热门电子游戏、老虎机与街机主题娱乐内容。",
    offerHeading: "新用户欢迎优惠",
    offerBadge: "新用户专享",
    offerTitle: "欢迎优惠",
    offerNote: "具体资格、金额上限、存款条件、流水要求及有效期以合作平台官网最新活动条款为准。",
    featuresHeading: "平台特点",
    f1Title: "多种充值方式",
    f1Desc: "支持多种支付方式，实际可用方式以目标平台和用户所在地区为准。",
    f2Title: "丰富娱乐内容",
    f2Desc: "体育、真人娱乐、电子游戏等多种内容选择。",
    f3Title: "手机端访问",
    f3Desc: "优先适配移动端，随时随地流畅访问。",
    f4Title: "多语言支持",
    f4Desc: "提供多语言界面，方便不同地区用户浏览。",
    noticeHeading: "风险与说明",
    disclaimerText: "本站为独立推广/信息页面，不直接提供博彩交易或资金服务。具体服务、活动及条款以合作平台官网为准。",
    responsible: "18+｜请理性娱乐｜博彩存在资金损失风险｜请遵守所在地法律法规",
    copyright: "© 2026 亚洲体育与娱乐指南 · 独立第三方资讯页面",
  },
  "zh-TW": {
    kicker: "獨立第三方 · 資訊與推廣指南",
    heroLine1: "亞洲體育",
    heroLine2: "與娛樂指南",
    heroSubtitle: "熱門體育賽事、真人娛樂及電子遊戲內容，查看當前平台活動與新用戶優惠。",
    cta: "立即進入",
    categoriesHeading: "熱門分類",
    sportsTitle: "體育賽事",
    sportsDesc: "足球、籃球等全球熱門賽事內容與賽事情報。",
    casinoTitle: "真人娛樂",
    casinoDesc: "真人桌台互動，沉浸式豪華娛樂大廳體驗。",
    slotsTitle: "電子遊戲",
    slotsDesc: "熱門電子遊戲、老虎機與街機主題娛樂內容。",
    offerHeading: "新用戶歡迎優惠",
    offerBadge: "新用戶專享",
    offerTitle: "歡迎優惠",
    offerNote: "具體資格、金額上限、存款條件、流水要求及有效期以合作平台官網最新活動條款為準。",
    featuresHeading: "平台特點",
    f1Title: "多種充值方式",
    f1Desc: "支援多種支付方式，實際可用方式以目標平台和用戶所在地區為準。",
    f2Title: "豐富娛樂內容",
    f2Desc: "體育、真人娛樂、電子遊戲等多種內容選擇。",
    f3Title: "手機端訪問",
    f3Desc: "優先適配移動端，隨時隨地流暢訪問。",
    f4Title: "多語言支援",
    f4Desc: "提供多語言介面，方便不同地區用戶瀏覽。",
    noticeHeading: "風險與說明",
    disclaimerText: "本站為獨立推廣/資訊頁面，不直接提供博彩交易或資金服務。具體服務、活動及條款以合作平台官網為準。",
    responsible: "18+｜請理性娛樂｜博彩存在資金損失風險｜請遵守所在地法律法規",
    copyright: "© 2026 亞洲體育與娛樂指南 · 獨立第三方資訊頁面",
  },
  en: {
    kicker: "Independent Third-Party Info & Promo Guide",
    heroLine1: "Asia Sports",
    heroLine2: "& Entertainment Guide",
    heroSubtitle: "Popular sports events, live casino and e-games. Explore current platform promotions and new-user offers.",
    cta: "Enter Now",
    categoriesHeading: "Top Categories",
    sportsTitle: "Sports",
    sportsDesc: "Football, basketball and other major global events and insights.",
    casinoTitle: "Live Casino",
    casinoDesc: "Live-dealer tables in an immersive luxury gaming hall.",
    slotsTitle: "E-Games",
    slotsDesc: "Popular slots, arcade and electronic game titles.",
    offerHeading: "New User Welcome Offer",
    offerBadge: "New Users Only",
    offerTitle: "Welcome Offer",
    offerNote: "Eligibility, caps, deposit conditions, turnover requirements and validity are subject to the latest promotion terms on the partner platform's official site.",
    featuresHeading: "Platform Highlights",
    f1Title: "Multiple Top-Up Methods",
    f1Desc: "Multiple payment methods supported; availability depends on the platform and your region.",
    f2Title: "Rich Entertainment",
    f2Desc: "Sports, live casino, e-games and more.",
    f3Title: "Mobile First",
    f3Desc: "Optimized for mobile, smooth access anytime.",
    f4Title: "Multi-Language",
    f4Desc: "Multiple interface languages for users in different regions.",
    noticeHeading: "Risk & Notice",
    disclaimerText: "This is an independent promotional/information page and does not provide betting transactions or fund services. Services, promotions and terms are subject to the partner platform's official site.",
    responsible: "18+ | Play Responsibly | Betting involves risk of loss | Comply with local laws",
    copyright: "© 2026 Asia Sports & Entertainment Guide · Independent Info Page",
  },
  vi: {
    kicker: "Trang thông tin & quảng bá độc lập",
    heroLine1: "Thể Thao Châu Á",
    heroLine2: "& Giải Trí Trực Tuyến",
    heroSubtitle: "Sự kiện thể thao hot, casino trực tiếp và game điện tử. Xem khuyến mãi nền tảng và ưu đãi thành viên mới.",
    cta: "Vào Ngay",
    categoriesHeading: "Danh Mục Hot",
    sportsTitle: "Thể Thao",
    sportsDesc: "Bóng đá, bóng rổ và các sự kiện thể thao hàng đầu thế giới.",
    casinoTitle: "Casino Trực Tiếp",
    casinoDesc: "Bàn chơi người thật, sảnh giải trí sang trọng đắm chìm.",
    slotsTitle: "Game Điện Tử",
    slotsDesc: "Slot, arcade và game điện tử chủ đề đa dạng.",
    offerHeading: "Ưu Đãi Chào Mừng Thành Viên Mới",
    offerBadge: "Dành Cho Thành Viên Mới",
    offerTitle: "Ưu Đãi Chào Mừng",
    offerNote: "Điều kiện, hạn mức, yêu cầu nạp tiền, vòng cược và thời hạn theo điều khoản khuyến mãi mới nhất trên website chính thức của nền tảng.",
    featuresHeading: "Điểm Nổi Bật",
    f1Title: "Nhiều Cách Nạp Tiền",
    f1Desc: "Hỗ trợ nhiều phương thức thanh toán; tùy nền tảng và khu vực của bạn.",
    f2Title: "Nội Dung Phong Phú",
    f2Desc: "Thể thao, casino trực tiếp, game điện tử và nhiều hơn nữa.",
    f3Title: "Truy Cập Di Động",
    f3Desc: "Tối ưu cho điện thoại, truy cập mượt mà mọi lúc.",
    f4Title: "Đa Ngôn Ngữ",
    f4Desc: "Giao diện nhiều ngôn ngữ cho người dùng các khu vực.",
    noticeHeading: "Lưu Ý & Rủi Ro",
    disclaimerText: "Đây là trang thông tin/quảng bá độc lập, không cung cấp giao dịch cá cược hay dịch vụ tài chính. Dịch vụ, khuyến mãi và điều khoản theo website chính thức của nền tảng.",
    responsible: "18+ | Chơi có trách nhiệm | Cá cược có rủi ro mất tiền | Tuân thủ pháp luật địa phương",
    copyright: "© 2026 Hướng Dẫn Thể Thao & Giải Trí Châu Á · Trang thông tin độc lập",
  },
  th: {
    kicker: "เพจข้อมูลและโปรโมชันอิสระ",
    heroLine1: "เอเชียสปอร์ต",
    heroLine2: "& ความบันเทิงออนไลน์",
    heroSubtitle: "กีฬายอดนิยม คาสิโนสด และเกมอิเล็กทรอนิกส์ ดูโปรโมชันแพลตฟอร์มและข้อเสนอสมาชิกใหม่",
    cta: "เข้าสู่เว็บไซต์",
    categoriesHeading: "หมวดยอดนิยม",
    sportsTitle: "กีฬา",
    sportsDesc: "ฟุตบอล บาสเกตบอล และการแข่งขันระดับโลก",
    casinoTitle: "คาสิโนสด",
    casinoDesc: "โต๊ะดีลเลอร์สด บรรยากาศหรูหราสมจริง",
    slotsTitle: "เกมอิเล็กทรอนิกส์",
    slotsDesc: "สล็อต อาร์เคด และเกมยอดนิยม",
    offerHeading: "โบนัสต้อนรับสมาชิกใหม่",
    offerBadge: "เฉพาะสมาชิกใหม่",
    offerTitle: "โบนัสต้อนรับ",
    offerNote: "คุณสมบัติ วงเงินสูงสุด เงื่อนไขการฝาก เทิร์นโอเวอร์ และระยะเวลา เป็นไปตามเงื่อนไขโปรโมชันล่าสุดบนเว็บไซต์อย่างเป็นทางการของแพลตฟอร์ม",
    featuresHeading: "จุดเด่นแพลตฟอร์ม",
    f1Title: "ช่องทางเติมเงินหลากหลาย",
    f1Desc: "รองรับหลายช่องทางชำระเงิน ขึ้นกับแพลตฟอร์มและภูมิภาคของคุณ",
    f2Title: "ความบันเทิงครบครัน",
    f2Desc: "กีฬา คาสิโนสด เกมอิเล็กทรอนิกส์ และอื่นๆ",
    f3Title: "เข้าผ่านมือถือ",
    f3Desc: "ออกแบบสำหรับมือถือ เข้าใช้ได้ลื่นไหลทุกที่",
    f4Title: "รองรับหลายภาษา",
    f4Desc: "เมนูหลายภาษาสำหรับผู้ใช้ทุกภูมิภาค",
    noticeHeading: "ข้อควรทราบ",
    disclaimerText: "เว็บไซต์นี้เป็นเพจข้อมูล/โปรโมชันอิสระ ไม่ได้ให้บริการเดิมพันหรือบริการทางการเงิน บริการ โปรโมชัน และเงื่อนไขเป็นไปตามเว็บไซต์อย่างเป็นทางการของแพลตฟอร์ม",
    responsible: "18+ | เล่นอย่างมีความรับผิดชอบ | การเดิมพันมีความเสี่ยงสูญเสียเงิน | ปฏิบัติตามกฎหมายท้องถิ่น",
    copyright: "© 2026 คู่มือกีฬาและความบันเทิงเอเชีย · เพจข้อมูลอิสระ",
  },
  ms: {
    kicker: "Halaman maklumat & promosi bebas",
    heroLine1: "Sukan Asia",
    heroLine2: "& Hiburan Dalam Talian",
    heroSubtitle: "Acara sukan popular, kasino langsung dan permainan elektronik. Lihat promosi platform dan tawaran pengguna baharu.",
    cta: "Masuk Sekarang",
    categoriesHeading: "Kategori Popular",
    sportsTitle: "Sukan",
    sportsDesc: "Bola sepak, bola keranjang dan acara sukan global terkini.",
    casinoTitle: "Kasino Langsung",
    casinoDesc: "Meja peniaga langsung, dewan hiburan mewah yang imersif.",
    slotsTitle: "Permainan Elektronik",
    slotsDesc: "Slot, arked dan permainan elektronik popular.",
    offerHeading: "Tawaran Selamat Datang Pengguna Baharu",
    offerBadge: "Khas Pengguna Baharu",
    offerTitle: "Tawaran Selamat Datang",
    offerNote: "Kelayakan, had jumlah, syarat deposit, keperluan turnover dan tempoh sah tertakluk pada terma promosi terkini di laman rasmi platform.",
    featuresHeading: "Ciri Platform",
    f1Title: "Pelbagai Kaedah Tambah Nilai",
    f1Desc: "Pelbagai kaedah pembayaran disokong; bergantung pada platform dan wilayah anda.",
    f2Title: "Kandungan Hiburan Lengkap",
    f2Desc: "Sukan, kasino langsung, permainan elektronik dan banyak lagi.",
    f3Title: "Akses Mudah Alih",
    f3Desc: "Dioptimumkan untuk telefon, akses lancar bila-bila masa.",
    f4Title: "Sokongan Berbilang Bahasa",
    f4Desc: "Antara muka pelbagai bahasa untuk pengguna pelbagai wilayah.",
    noticeHeading: "Notis & Risiko",
    disclaimerText: "Laman ini adalah halaman maklumat/promosi bebas dan tidak menyediakan transaksi pertaruhan atau perkhidmatan kewangan. Perkhidmatan, promosi dan terma tertakluk pada laman rasmi platform.",
    responsible: "18+ | Main dengan bertanggungjawab | Pertaruhan melibatkan risiko kerugian | Patuhi undang-undang tempatan",
    copyright: "© 2026 Panduan Sukan & Hiburan Asia · Halaman maklumat bebas",
  },
};

export const pageTitles = {
  "zh-CN": "亚洲体育与娱乐指南",
  "zh-TW": "亞洲體育與娛樂指南",
  en: "Asia Sports & Entertainment Guide",
  vi: "Hướng Dẫn Thể Thao & Giải Trí Châu Á",
  th: "คู่มือกีฬาและความบันเทิงเอเชีย",
  ms: "Panduan Sukan & Hiburan Asia",
};
